import { render, staticRenderFns } from "./subtasks-component.vue?vue&type=template&id=01c13133"
import script from "./subtasks-component.vue?vue&type=script&lang=js"
export * from "./subtasks-component.vue?vue&type=script&lang=js"
import style0 from "./subtasks-component.vue?vue&type=style&index=0&id=01c13133&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports